import { Link } from 'react-router-dom';

import logo from './finch-logo-flat.svg';

interface FinchLogoFlatProps {
  style?: React.CSSProperties;
  disableLink?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

export const FinchLogoFlat = ({
  style,
  disableLink = false,
  onClick,
}: FinchLogoFlatProps) => {
  const logoElement = (
    <button
      type="button"
      style={{
        position: 'relative',
        display: 'inline-flex',
        cursor: 'pointer',
        background: 'none',
        border: 'none',
        padding: 0,
      }}
      onClick={onClick}
      aria-label="Toggle holiday mode"
    >
      <img src={logo} alt="Finch Logo" style={{ width: '24px', ...style }} />
    </button>
  );

  if (disableLink) {
    return logoElement;
  }

  return (
    <Link to="/" style={{ display: 'flex', textDecoration: 'none' }}>
      {logoElement}
    </Link>
  );
};
